// extracted by mini-css-extract-plugin
export var Alert = "Favourites-module--Alert--b2b12";
export var Base = "Favourites-module--Base--6a328";
export var Saved = "Favourites-module--Saved--411f8";